import { ThirdPartyData } from "./import";

export class CountWidgetSettings {
  context: string | number[];
  typeId: number;
  stateId: number;
  state: string;
  status: string;
  category: string;
  caseType: string;
  referralCounts: boolean;
  caseOrReferralDueReview: boolean;
  //could have a dueReview flag, then i can set this in settings and then in the label service check for this on settings

  // showStatus: boolean;
  showFlags: number;
  organisationId: number;
  color: any;
  title: string;
  label: string;
  showExtra: boolean;
  extraTypeId: number;
  extraStateId: number;
  extraState: string;
  extraStatus: string;
  extraCaseType: string;
  extraCategory: string;
  extraLabel: string;
  users: number[];
  filterId: number;
  constructor(settings?) {
    settings = settings || {};
    this.context = settings.context || 'All';
    this.typeId = settings.typeId;
    this.stateId = settings.stateId;
    this.state = settings.state;
    this.status = settings.status;
    this.caseType = settings.caseType;
    this.category = settings.category;
    this.referralCounts = settings.referralCounts;    

    // this.showStatus = settings.showStatus;
    this.showFlags = settings.showFlags;

    this.organisationId = settings.organisationId;
    this.color = settings.color || '#f44336';
    this.showExtra = settings.showExtra || false;
    this.extraTypeId = settings.extraTypeId;
    this.extraStateId = settings.extraStateId;
    this.extraState = settings.extraState;
    this.extraStatus = settings.extraStatus;
    this.extraCaseType = settings.extraCaseType;
    this.extraCategory = settings.extraCategory;
    this.extraLabel = settings.extraLabel;
    this.users = [];
    this.title = settings.title;
    this.label = settings.label;

    this.filterId = settings.filterId;
    this.caseOrReferralDueReview = settings.caseOrReferralDueReview;
  }
}
